module.exports = __webpack_public_path__ + "img/medium-new.d5ccd773.svg";